
/**
* AdapterRequest类
* Description: 迅雷盒子设备远程模块接口适配器类
* @constructor
* @param {TRequestInterceptorFunc[]} requestInterceptors - 请求拦截器
* @param {TResponseInterceptorFunc[]} responseInterceptors - 响应拦截器
* @author : lushaoqing
* @date : 2022/12/06 16:00
*
*/

import { API, apiEnv } from '@remote/api/config'
import { request } from '@remote/api/request'
import { normalizeUrl } from './helper'
import { TRequestInterceptorFunc, TResponseInterceptorFunc, TRequest } from './index.d'

class AdapterRequest {
  private requestInterceptors: TRequestInterceptorFunc[]
  private responseInterceptors: TResponseInterceptorFunc[]

  constructor (requestInterceptors: TRequestInterceptorFunc[], responseInterceptors: TResponseInterceptorFunc[]) {
    this.requestInterceptors = requestInterceptors
    this.responseInterceptors = responseInterceptors
  }
  // request方法劫持
  request: TRequest = async (url, params = {}, options = {}) => {
    const host = API[options.apiEnv || apiEnv]
    const requestUrl = normalizeUrl(url, host)
    // requestInterceptors todos
    let requestInterceptorResult = Promise.resolve({ config: { url: requestUrl, params, options }, response: null })
    for (let i = 0; i < this.requestInterceptors.length; i++) {
      requestInterceptorResult = requestInterceptorResult.then(this.requestInterceptors[i])
    }

    const { config, response } = await requestInterceptorResult
    // 如果request拦截器中有数据返回直接使用数据返回,便于mock数据
    if (response) return response

    // responseInterceptors todos
    let responseInterceptorResult = request(config.url, config.params, config.options)
    for (let i = 0; i < this.responseInterceptors.length; i++) {
      responseInterceptorResult = responseInterceptorResult
        .then(this.responseInterceptors[i].bind(null, config))
        .catch(err => {
          console.error('responseInterceptorResult', err)
        })
    }

    return responseInterceptorResult
  }
}

export default AdapterRequest